import { type NavigationGuard } from 'vue-router';
import { type AuthenticationQuery, useAuthenticationQuery } from '@/composables/authentication.ts';
import { useCompanyAction } from '@/composables/company.ts';

// eslint-disable-next-line func-style
export const initCustomerCompany: NavigationGuard = async (to) => {
    const authenticationQuery: AuthenticationQuery = useAuthenticationQuery();
    const companyAction = useCompanyAction();

    if (authenticationQuery.isUserLoggedIn.value) {
        await companyAction.findCustomerCompanyIfMissing();
    }

    return true;
};
